export function useTiming() {
	let timeoutMap = new Map();
	function timeoutHelper(callback: any, duration: any) {
		clearTimeout(timeoutMap.get(callback));
		
		const timer = setTimeout(() => {
			callback();
			clearTimeout(timer);
			timeoutMap.delete(callback);
		}, duration);
		
		timeoutMap.set(callback, timer);
	}

	function sleep(ms: number) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	function debounce<T extends (...args: any[]) => void>(func: T, delay: number): T {
		let timer: ReturnType<typeof setTimeout>;
		return function (this: any, ...args: Parameters<T>) {
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		} as T;
	}

	return {
		timeoutHelper,
		sleep,
		debounce
	};
}
  